import styled from 'styled-components';
import { MenuItem, Select, Tooltip, Typography, } from '@mui/material';
export const StyledSelect = styled(Select) `
  font-size: 0.9em;
  min-width: max-content;

  .MuiSelect-select {
    padding-right: ${({ theme }) => theme.spacing(4)};
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .MuiPaper-root {
    min-width: ${({ theme }) => theme.spacing(25)};
    max-width: ${({ theme }) => theme.spacing(50)};
  }
  
  .MuiSelect-select,
  .MuiMenuItem-root,
  .MuiTypography-root {
    white-space: nowrap;
  }
`;
export const StyledMenuItem = styled(MenuItem) `
  padding: ${({ theme }) => theme.spacing(1, 2)};
  justify-content: flex-start;
  
  &:hover {
    background-color: ${({ theme }) => theme.palette.action.hover};
  }
`;
export const StyledTooltip = styled(Tooltip) `
  .MuiTooltip-tooltip {
    background-color: ${({ theme }) => theme.palette.grey[800]};
    color: white;
    font-size: 0.875rem;
    max-width: ${({ theme }) => theme.spacing(37.5)};
    padding: ${({ theme }) => theme.spacing(1, 1.5)};
    word-wrap: break-word;
    white-space: normal;
  }
`;
export const StyledSelectLabel = styled(Typography) `
  display: inline-block;
`;
